import { z } from 'zod';
import { BigdesDefinitionSchema } from './bigdes-base.schema.js';

export const DataSourceSchema = BigdesDefinitionSchema.extend({});
export const CreateDataSourceSchema = DataSourceSchema.omit({ id: true, createdAt: true, updatedAt: true });
export const UpdateDataSourceSchema = DataSourceSchema.partial();
